import React, { PropsWithChildren } from 'react';

export interface HeaderProps {
  label: string | JSX.Element;
  className?: string;
}

export const Header: React.FC<PropsWithChildren<HeaderProps>> = (props) => {
  return (
    <div className={['d-flex', props.className].filter((c) => c).join(' ')} style={{ backgroundColor: '#BAE3E1', minHeight: '40px' }}>
      <div className="flex-grow-1 d-flex align-items-center">
        <h6 style={{ color: '#353D3D' }} className="px-2 m-0">
          {props.label}
        </h6>
      </div>
      <div className="text-nowrap">{props.children}</div>
    </div>
  );
};
